// Espanõl
export const es = {
  translation: {
    "Save": "Guardar",
    "Select Dispatch Group": "Seleccionar Grupo de Despacho",
    "This entry has no location (latitude/longitude). Please select a dispatch group to continue.":
      "Esta entrada no tiene ubicación (latitud/longitud). Seleccione un grupo de despacho para continuar.",
    "Suggested dispatch groups based on entry type/subtype:":
      "Grupos de despacho sugeridos según tipo/subtipo de entrada:",
    "No dispatch groups found for this entry type/subtype":
      "No se encontraron grupos de despacho para este tipo/subtipo",
    "Error loading suggested dispatch groups":
      "Error al cargar grupos de despacho sugeridos",
    "Dispatch group added successfully": "Grupo de despacho agregado con éxito",
    "Error adding dispatch group": "Error al agregar grupo de despacho",
    "Entry saved and dispatch group added successfully":
      "Entrada guardada y grupo de despacho agregado con éxito",
    "Entry saved and dispatch group added":
      "Entrada guardada y grupo de despacho agregado",
    "Cancel": "Cancelar"
  }
}